module.exports = __webpack_public_path__ + "static/media/sass.fbd9f99f.png";